import { Feature } from "ol";
import { updateInfo } from "./index";
import { DIV, emptyElement, H3, UL, LI, BUTTON } from "./dom";
import { tr } from "./locale";
import type { DataContext } from "./index";

const renderFeatureList = (
  features: Feature[],
  selectProject: (id: number) => void,
  clearSelection: () => void,
  dataContext: DataContext,
) =>
  DIV(
    "feature-list",
    H3("subtitle", tr("selected_projects"), BUTTON('close', clearSelection)),
    UL(
      "list",
      ...features.map((f) =>
        dataContext.getFeatureID(f).map((id) =>
          LI(
            "feature-item",
            BUTTON(
              "",
              () => selectProject(id),
              dataContext.getFeatureName(f).getOrElse(id.toString()),
            ),
          ),
        ),
      ),
    ),
  );

export const featuresInfoFactory =
  (parent: Element, dataContext: DataContext) =>
  (features: Feature[], selectProject: (id: number) => void, selectProjectsWithoutGeom: ()=>void, clearSelection: ()=>void) => {
    emptyElement(parent);
    if (features.length >= 1) {
      const summary = DIV(
        "summary",
        // H2("summary-title", tr("aggregated_data"), ` (${features.length})`),
        // DIV("value", DIV("key", tr("nb_projects")), features.length),

        renderFeatureList(features, selectProject, clearSelection, dataContext),
      );
      parent.appendChild(summary);
    } else {
      updateInfo(parent, selectProjectsWithoutGeom);
    }
  };
